import { Nullable } from "@/api/ApiClient";
import { WithReferenceCode } from "./ReferenceCodeType";

export type DebitnoteFormData = WithReferenceCode<Nullable<{
    id: string,
    numero: number,
    sequence: string,
    document_key: string,
    description: string,
    email: string,
    subtotal: number,
    descuento: number,
    discountCode: string,
    impuestos: number,
    impuestos_servicio: number,
    total: number,
    exchange_rate: number,
    edocument_status: number,
    edocument_status_payload: string,
    created: string,
    applied:boolean,
    activitycode: string,
    applied_date:string,
    selected_logo: number,
    excludeFromReport: boolean,
    price_note: boolean,
    anulada: boolean,
    info_references: string,
    otros_cargos: string,
    clientId: string,
    client: any,
    currencyId: string,
    currency: any,
    invoiceId: string,
    invoice: any,
    appliedInvoiceId: string,
    appliedInvoice: any,
    debitnoteProducts: any[],
    user: string,
}>>

export const DebitnoteRelatedAttributes: Array<keyof DebitnoteFormData> = ["client", "currency", "invoice", "appliedInvoice", "debitnoteProducts"];